exports = module.exports = require("../../../node_modules/_css-loader@0.28.11@css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/_css-loader@0.28.11@css-loader?{"minimize":false,"sourceMap":false,"importLoaders":2}!./node_modules/_postcss-loader@2.0.10@postcss-loader/lib?{"sourceMap":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/client/client.scss
// module id = ./node_modules/_css-loader@0.28.11@css-loader/index.js?{"minimize":false,"sourceMap":false,"importLoaders":2}!./node_modules/_postcss-loader@2.0.10@postcss-loader/lib/index.js?{"sourceMap":false}!./node_modules/_sass-loader@6.0.7@sass-loader/lib/loader.js?{"sourceMap":false}!./src/views/client/client.scss
// module chunks = 3